/**
 * Escaping for user-controlled text going into hand-built HTML.
 *
 * The web app renders most of its UI by string interpolation, so any value that came
 * from the user — a goal name, a category label, a merchant — has to be escaped before
 * it reaches markup, and doubly so inside an attribute, where an unescaped quote ends
 * the attribute and starts whatever follows.
 *
 * This existed three times, byte-identical and private, in WebDebtStudioComponent,
 * WebBudgetPlanningComponent and WebStudioComponent. One copy now.
 */
object HtmlEscape {

    /**
     * Safe for both element text and quoted attribute values: `&` first (or the later
     * replacements would be escaped a second time), then the three characters that can
     * break out of either context.
     */
    fun escape(s: String): String = s
        .replace("&", "&amp;")
        .replace("<", "&lt;")
        .replace(">", "&gt;")
        .replace("\"", "&quot;")
}

/** Shorthand for [HtmlEscape.escape] at interpolation sites. */
fun String.escapeHtml(): String = HtmlEscape.escape(this)
